"use client"

import { CopyPlus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CopyPlusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CopyPlusIcon = component(Icon)({ as: CopyPlus })
